import MagicGrid from 'magic-grid' // カードレイアウト

if (document.getElementById('system-card-list')) {
  cardList()
}

function cardList() {
  const frame = document.getElementById('cardList')
  if (!frame) {
    return
  }
  const magicGrid = new MagicGrid({
    container: '#cardList', // 対象要素
    static: false, // Required for static content. Default: false.
    items: frame.dataset.count, // アイテムの個数
    gutter: 10, // アイテムの間隔
    maxColumns: 20, // 最大カラム数
    useMin: true, // Optional. Prioritize shorter columns when positioning items. Default: false.
    useTransform: true, // Optional. Position items using CSS transform. Default: True.
    animate: true, // アニメーション
  })
  magicGrid.listen() // 実行
}
